import { QueryDocumentSnapshot } from "@firebase/firestore-types";
import { Businesses, Theme } from "@just-in-types";
import { AnyAction, Dispatch } from "redux";
import { firestore } from "../../firebase";

const businessesRef = firestore.collection("businesses");

export const SET_ROUTES = "routes.SET_ROUTES";
export const setRoutes = () => async (dispatch: Dispatch<AnyAction>) => {
  const businessesSnapshot = await businessesRef.get();
  const getSites = async (business: QueryDocumentSnapshot) => {
    try {
      const sitesSnapshot = await business.ref.collection("sites").get();
      const sites: Businesses.Site[] = [];

      sitesSnapshot.forEach((site) =>
        sites.push({ siteId: site.id, ...(site.data() as Businesses.Site) })
      );

      return dispatch({
        payload: { businessId: business.id, ...business.data(), sites },
        type: SET_ROUTES,
      });
    } catch (error) {
      throw new Error(error);
    }
  };

  // @ts-ignore
  const promises = Promise.all(
    businessesSnapshot.docs.map((doc) => getSites(doc))
  );
  await promises;

  // return businessesSnapshot.forEach((doc) => getSites(doc));
};

export const SET_THEME = "theme.SET_THEME";
export const setTheme: SetTheme = (theme: Theme.Props) => (
  dispatch: Dispatch<AnyAction>
) => dispatch({ type: SET_THEME, payload: theme });

export type SetRoutes = () => (dispatch: Dispatch<AnyAction>) => Promise<void>;
export type SetTheme = (
  theme: Theme.Props
) => (
  dispatch: Dispatch<AnyAction>
) => {
  type: string;
  payload: Theme.Props;
};



// WEBPACK FOOTER //
// ./src/store/actions/businessActions.ts